import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { CompleteParticipantEventJourney } from 'containers/forms/dashboard'
import { MaterialModal } from 'components/layout'

export default class CompleteParticipantEventJourneyModal extends Component {
  static propTypes = {
    colorClass: PropTypes.string,
    modalId: PropTypes.string,
  }

  render() {
    const { colorClass, modalId } = this.props

    return (
      <MaterialModal.Body
        id={modalId}
        colorClass={colorClass}
        title='Complete Report'
        titleKey='moduleTitle.complete_report'
      >
        <MaterialModal.Content>
          <CompleteParticipantEventJourney {...this.props} />
        </MaterialModal.Content>
      </MaterialModal.Body>
    )
  }
}
